import { c as _c } from "react/compiler-runtime";
import { AspectRatio } from "@repo/ui/components/ui/aspect-ratio";
import { cn } from "@repo/ui/lib/utils";
import { Link } from "@tanstack/react-router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ExperienceGridCard(t0) {
  const $ = _c(26);
  const {
    experience,
    size: t1
  } = t0;
  const size = t1 === undefined ? "regular" : t1;
  let t2;
  if ($[0] !== experience.media) {
    t2 = experience.media?.find(_temp);
    $[0] = experience.media;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const primaryMedia = t2;
  let t3;
  if ($[2] !== experience.titleSlug) {
    t3 = {
      slug: experience.titleSlug
    };
    $[2] = experience.titleSlug;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("group/card relative block w-full overflow-hidden rounded-lg bg-black ring-offset-background transition-colors", "hover:ring-1 hover:ring-primary hover:ring-offset-1", "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = size === "regular" ? 0.7142857142857143 : 1.5;
  let t6;
  if ($[5] !== experience.title || $[6] !== primaryMedia) {
    t6 = primaryMedia && /*#__PURE__*/_jsx("img", {
      src: primaryMedia.url,
      alt: primaryMedia.altText || experience.title,
      className: "h-full w-full object-cover transition-transform duration-500 group-hover/card:scale-[1.03]"
    });
    $[5] = experience.title;
    $[6] = primaryMedia;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = /*#__PURE__*/_jsx(AspectRatio, {
      ratio: t5,
      children: t6
    });
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = experience.subtitle ? "h-[4.5rem] group-hover/card:h-40" : "h-[4.5rem]";
  let t9;
  if ($[11] !== t8) {
    t9 = cn("absolute inset-x-0 bottom-0 flex flex-col justify-end p-4 transition-all duration-300", t8);
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== experience.title) {
    t10 = /*#__PURE__*/_jsx("h3", {
      className: "text-lg font-bold text-white",
      children: experience.title
    });
    $[13] = experience.title;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== experience.subtitle) {
    t11 = experience.subtitle && /*#__PURE__*/_jsx("p", {
      className: "mt-2 line-clamp-2 text-sm text-white/0 transition-all duration-300 group-hover/card:text-white/80",
      children: experience.subtitle
    });
    $[15] = experience.subtitle;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = /*#__PURE__*/_jsx("div", {
      className: "absolute bottom-0 left-0 h-1 w-0 bg-primary transition-all duration-300 group-hover/card:w-full"
    });
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t13 = /*#__PURE__*/_jsx("div", {
      className: "absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-opacity duration-300 group-hover/card:opacity-90",
      children: /*#__PURE__*/_jsxs("div", {
        className: t9,
        children: [t10, t11, t12]
      })
    });
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t3 || $[24] !== t7) {
    t14 = /*#__PURE__*/_jsxs(Link, {
      to: "/upplevelser/$slug",
      params: t3,
      className: t4,
      children: [t7, t13]
    });
    $[22] = t13;
    $[23] = t3;
    $[24] = t7;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
}
function _temp(m) {
  return m.isPrimary;
}